import { Modal, message } from 'antd';

import { cancelMatch } from 'api/events';
import { matchStatuses } from 'configs';
import { messages } from 'constants/index';
import { requestFeedback } from 'utils';

const { confirm } = Modal;
const { CANCELLED } = matchStatuses;

export const cancelMatchModal = (matchDayId, matchId, onLoadRounds, setIsModalVisible) => {
  confirm({
    title: '¿Deseas cancelar este encuentro?',
    content: 'Se notificará a todos los integrantes de ambos equipos',
    okText: 'Cancelar encuentro',
    okType: 'danger',
    cancelText: 'Cerrar',
    onOk() {
      (async () => {
        try {
          const { status } = await cancelMatch(Number(matchDayId), Number(matchId), CANCELLED);
          await onLoadRounds();
          setIsModalVisible(false);
          requestFeedback(status, messages.onMatchCanceled);
        } catch (error) {
          message.error(messages.onError);
        }
      })();
    },
    onCancel() {},
  });
};
